import type { UseMutationResult } from '@tanstack/react-query';
import { useBffPostMutation } from '../bff';
import type { StoresSearchInventoryRequest } from './model';
import type { Stores } from './model/Store';

export const useStoreSearch = (): UseMutationResult<
    Stores,
    unknown,
    StoresSearchInventoryRequest
> => useBffPostMutation<Stores, StoresSearchInventoryRequest>('/stores/search');
